/// <reference path="../node_modules/jquery/src/jquery.js"/>
/// <reference path="../node_modules/foundation-sites/dist/js/foundation.d.ts"/>
/// <reference path="../node_modules/slick-carousel/slick/slick.js"/>

/// <reference path="./modules/fx.js"/>
/// <reference path="./modules/dynamic_grid.js"/>
/// <reference path="./modules/portfolio.js"/>
/// <reference path="./modules/about.js"/>
/// <reference path="./modules/contact_form.js"/>

//
// IE fixes
//
if (typeof Array.prototype.fill === "undefined") {
	Array.prototype.fill = function (value, start = 0, end = null) {
		for (let i = start; i < end || this.length; i++) {
			this[i] = value;
		}

		return this;
	}
}

function checkScroll() {
	if (window.scrollY > 98) $(document.body).addClass("scrolled");
	else {
		$(document.body).removeClass("scrolled");
	}

	$("[lazy-load-image]").each((_index, element) => {
		const {top, height} = element.getBoundingClientRect();

		if (height > 0 && (top <= window.innerHeight || (top + height >= 0 && top + height <= window.innerHeight))) {
			const image = $(element);

			image.css("background-image", `url(${image.attr("lazy-load-image")})`);
			image.removeAttr("lazy-load-image");
		}
	});
}

$("header.use-menu-logo").removeClass("use-menu-logo");

$(document).on("click", "a:not([target=_blank]):not([no-transition])", function(event) {
	if ($(this).attr("href").startsWith("tel:") || $(this).attr("href").startsWith("mailto:")) return;

	const m_color = $(this).attr("transition-color");
	const href = $(this).attr("transition-href") || $(this).attr("href");
	event.preventDefault();
	$.get(m_color ? "/home/color" : `${href == "/" ? `${window.location.protocol}//${window.location.hostname}/home/` : href}color`).then(color => {
		$("#transition-frame").css("background-color", m_color || color).removeClass("slide-out").addClass("slide-in");
		$("header").addClass("use-menu-logo");

		window.localStorage.setItem("transition-href", href);

		setTimeout(() => window.location.href = $(this).attr("href"), 500);
	}).catch(() => window.location.href = $(this).attr("href"));
	return false;
});

checkScroll();
$(document).on("scroll", () => checkScroll());

if (navigator.userAgent.indexOf(".NET") > -1) {
	$(".blur-image").remove();
}

$(document).foundation();

// DynamicGrid.init();

$("header .open-menu").on("click", () => $("header").toggleClass("menu-open"));

$("form .field.text input").on("focus blur keyup", function(event) {
	const input = $(this);
	const field = input.parent().parent();

	if (event.type === "focus" || event.type === "keyup" || input.val().toString().length > 0) {
		field.addClass("active");
	}
	else {
		field.removeClass("active");
	}
});

function checkDarkSections() {
    if ($('body').hasClass('LandingPage')) return false;
	let useBlackBody = false;

	$(".dark-text-image").each((_index, element) => {
		const {top, bottom} = element.getBoundingClientRect();

		if (top <= innerHeight / 2 && bottom >= innerHeight / 2) {
			useBlackBody = true;
			$(element).addClass("use-white-fonts");
		}
		else {
			$(element).removeClass("use-white-fonts");
		}
	});

	if (useBlackBody) {
        $(document.body).addClass("use-black");
    } else {
        $(document.body).removeClass("use-black");
    }
}

let prevScroll = 0;
function checkHeaderScroll() {
	const header = $("header");

	if (window.scrollY > prevScroll) {
		if (!header.hasClass("menu-open")) header.addClass("scroll-down");

		header.removeClass("scroll-up");
	}
	else {
		header.removeClass("scroll-down");
		header.addClass("scroll-up");
	}

	if (window.scrollY <= 0) {
		header.addClass("very-top");
		header.removeClass("scroll-down");
		header.addClass("scroll-up");
	}
	else {
		header.removeClass("very-top");
	}

	if (window.scrollY <= 98) {
		header.addClass("at-top");
	}
	else {
		header.removeClass("at-top");
	}

	prevScroll = window.scrollY;
}

function checkLandingPage() {
    if (!$('body').hasClass('LandingPage')) return false;

    var elTop = $("#contact-form").offset().top; //gets offset of header

    $(window).scroll(function(){
        if($(window).scrollTop() > (elTop - 750)){
            $(document.body).removeClass("use-black");
        }
        else {
            if (!$(document.body).hasClass("use-black")) {
                $(document.body).addClass("use-black");
            }
        }
    });
}

function updateActiveCategoryBar() {
	const active = $(".category-links a.active");
	const inner = $(".category-links .inner");
	const {left: parentLeft} = active.parent()[0].getBoundingClientRect();
	const {left, width} = active[0].getBoundingClientRect();

	inner.css("--bar-width", `${width}px`);
	inner.css("--bar-offset", `${left - parentLeft}px`);
}

checkHeaderScroll();

document.addEventListener("DOMContentLoaded", () => {
	FX.init();
});

$(document).ready(() => {
	PortfolioPage.init();
	AboutPage.init();
	ContactForm.init();

    if($('.PortfolioPage').length) {
        updateActiveCategoryBar();
    	$(".category-links a").on("click", function() {
    		$(".category-links .inner").addClass("ready");
    		$(".category-links a").removeClass("active");
    		$(this).addClass("active");
    		updateActiveCategoryBar();
    	});
    }

	$("[animated-name]").each((_index, element) => {
		const strings = element.getAttribute("animated-name")
			.split(";")
			.filter(group => group.split(",").length == 3)
			.map(group => group.split(",")
			.map(str => str.trim()));

		function fillText(text, time) {
			return new Promise(resolve => {
				const timing = time / text.length;

				let index = 0;

				const interval = setInterval(() => {
					element.innerText += text[index];

					index++;

					if (element.innerText.length == text.length) {
						clearInterval(interval);
						resolve();
					}
				}, timing);
			});
		}

		function clearText(time) {
			return new Promise(resolve => {
				if (element.innerText.length == 0)
					return resolve();

				const timing = time / element.innerText.length;

				const interval = setInterval(() => {
					element.innerText = element.innerText.slice(0, -1);

					if (element.innerText.length == 0) {
						clearInterval(interval);
						resolve();
					}
				}, timing);
			});
		}

		function animate(index) {
			if (index >= strings.length) return;

			const [clearTime, text, fillTime] = strings[index];

			setTimeout(() => {
				clearText(clearTime).then(() => {
					setTimeout(() => {
						fillText(text, fillTime).then(() => {
							animate(index + 1);
						});
					}, 500);
				});
			}, 500);
		}

		animate(0);
	});


	checkDarkSections();
    checkLandingPage();
});

$(document).on("scroll", () => {
    checkLandingPage();
	checkDarkSections();
	checkHeaderScroll();
});


$(document).on("click", ".mobile-job-tile", function(event) {
	$(".mobile-job-tile").removeClass('open');
	$(this).toggleClass('open');
});